import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import RelativeLoading from 'modules/v2/common/AtomicDesign/RelativeLoading';

import { useDesignHuddle } from 'modules/v2/pages/TemplatesBuilder/DesignHuddleContext';
import DesignHuddleLayout from 'modules/v2/pages/TemplatesBuilder/layout';

function ProjectEditorFrame() {
  const location = useLocation();

  const { isConfigured, isTokenExpired, templateIsConfigured, setTemplateIsConfigured, setIsExportReady, isExportReady } = useDesignHuddle();

  const [templateId, setTemplateId] = useState('');
  const [projectId, setProjectId] = useState('');

  const editor = useRef<any>(null);

  const initializeIframe = (dhProjectId: string) => {
    if (editor.current) return;

    window.DSHDLib.Editors.insert(
      'dh-iframe-test',
      {
        project_id: dhProjectId,
      },
      (err: any, e: any) => {
        if (err) {
          console.log('Editor Configuration Error:', err);
        } else {
          editor.current = e;

          setTimeout(() => setIsExportReady(true), 3000);
        }
      }
    );
  };

  // const createProject = useCallback(() => {
  //   if (!templateId || projectId) return;

  //   const searchParams = new URLSearchParams(location.search);
  //   const customizations_hash = searchParams.get('customization_hashs');

  //   window.DSHDLib.createProject(
  //     {
  //       template_id: templateId,
  //       ...(customizations_hash && { customizations_hash }),
  //     },
  //     (err: any, data: any) => {
  //       if (err) {
  //         console.error('Template Builder Error:', err);
  //       } else {
  //         initializeIframe(data.project_id);
  //         setProjectId(data.project_id);
  //       }
  //     }
  //   );
  // }, [templateId, projectId, location.search]);

  // Detecta ID de template ou de projeto da URL
  useEffect(() => {
    const pathSegments = location.pathname.split('/');

    setProjectId(pathSegments[pathSegments.length - 1]);

    setTemplateIsConfigured(true);
  }, [location.pathname]);

  // Novo useEffect seguro que evita chamadas duplicadas
  useEffect(() => {
    if (!isConfigured || !templateIsConfigured || isTokenExpired) return;

    if (projectId) {
      initializeIframe(projectId);
    }
  }, [isConfigured, templateIsConfigured, isTokenExpired, projectId]);

  useEffect(() => {
    const handleExport = () => {
      editor.current.showExport();
    };

    window.addEventListener("show-export-template", handleExport);

    return () => {
      window.removeEventListener("show-export-template", handleExport);
    };
  }, []);

  if (!isConfigured || !templateIsConfigured) {
    return <RelativeLoading isLoading={true} />;
  }

  return (
    <div id="dh-iframe-test" className="h-[93vh] min-w-full" />
  );
}

export default function ProjectEditor() {
  return (
    <DesignHuddleLayout>
      <ProjectEditorFrame />
    </DesignHuddleLayout>
  );
}
